import React, { FunctionComponent, useMemo } from 'react';

import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { Sort, SortValue } from 'reviews2/feed/reviews-sort/ReviewsSort.types';

interface Props {
    selectedReviewsSort: Sort;
    onReviewsSortSelect: (selectedSort: Sort) => void;
    isNorthStarEnabled?: boolean;
}

export const DEFAULT_SELECTED_SORT: Sort = {
    label: 'SORT_NEWEST_CREATED',
    value: SortValue.NewestCreated,
};

export const ReviewsSort: FunctionComponent<Props> = ({
    selectedReviewsSort,
    onReviewsSortSelect,
    isNorthStarEnabled,
}) => {
    const { t } = useTranslation('reviews2');

    const SORT_OPTIONS: Sort[] = useMemo(() => {
        const sorts = [
            DEFAULT_SELECTED_SORT,
            {
                label: 'SORT_OLDEST_CREATED',
                value: SortValue.OldestCreated,
            },
            {
                label: 'SORT_NEWEST_ACTIVITY',
                value: SortValue.NewestActivity,
                divider: true,
            },
            {
                label: 'SORT_OLDEST_ACTIVITY',
                value: SortValue.OldestActivity,
            },
        ];

        return sorts;
    }, []);

    return (
        <div className="r4e-reviews-sort">
            <Dropdown className={`${isNorthStarEnabled ? 'north-star' : ''}`}>
                <Dropdown.Toggle variant="secondary" id="reviews-sort">
                    {t(selectedReviewsSort.label)}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {SORT_OPTIONS.map((sort) => {
                        return (
                            <div key={sort.value}>
                                {sort.divider && <Dropdown.Divider />}
                                <Dropdown.Item
                                    onClick={(e): void => {
                                        onReviewsSortSelect(sort);
                                    }}
                                >
                                    {t(sort.label)}
                                    {selectedReviewsSort.value === sort.value && <i className="icon-check" />}
                                </Dropdown.Item>
                            </div>
                        );
                    })}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};
